import React from "react";
import Arrow from "@children/assets/Arrow.jsx";
import s from "./Button.module.scss";

const Button = ({ text, type, loading, processingLabel, margin, handleClick }) => {
  return (
    <button
      onClick={handleClick}
      data-testid="cc-complete-order"
      style={{ marginTop: margin && margin + "px" }}
      className={`button button--submit ${s.button}`}
      id="hook-form"
      type={type}
      theme="purple"
      loading={`${String(loading)}`}
    >
      <span className="processing">{processingLabel}</span>
      <span className="cta__loading"></span>
      <span className={`submit__text ${s.submitText}`}>{text}</span>
      <span className={s.arrow}>
        <Arrow />
      </span>
    </button>
  );
};

export default Button;
